import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from 'react-select';

import FilterByInput from "../../../components/FilterByInput";

import * as admin10BdBeEmailsListActions from "../../../reducers/Admin/admin10BdBeEmailsListReducer";
import Helpers from "../../../utils/helpers";
import Pagination from "../../../components/Pagination/Pagination";
import { financialYears } from "../../../utils/helpers";
const tableHeading = [
  "Donor Name",
  "Email",
  "Phone",
  "PAN",
  "FY",
  "10BD Amount",
  "certificates expected",
  "certificates approved",
  "certificates Amount_matched",
  "Emails sent for",
  "Emails remaining",
  "Email Details",
];

const fy = financialYears();
let financialYear = [fy]
class Admin10BeBdEmails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      query: {},
      onNonProfitsSelected: [],
      isAllItemsSelected: false,
      ngoLoader : false,
      currentTab: "export",
      filters: [
        {
          label: "Search",
          type: [
  
            {
              type: "default",
              label: "Donor Name",
              query: "q",
            },
            {
              type: 'email',
              label: 'Email id',
              query: 'filter_by_user_email',
            },
            {
              type: "pan",
              label: "PAN",
              query: "filter_by_pan",
            },
            {
              type: "phone",
              label: "Phone",
              query: "filter_by_user_phone",
            },
          ],
          placeholder: "Search for NonProfit Name, ID, PAN",
        },
        {
          label: 'Certificates Approved',
          type: 'list',
          query: 'filter_by_status',
          lits:[{label: 'All', value:'all'}, {label: 'Complete', value:'complete'}, {label: 'Partial', value:'partial'}],
          filterType: 'multiple'
        },
        {
          label: 'NGO Expected from',
          type: 'service',
          query: 'filter_by_nonprofit',
          placeholder: 'Type nonprofit name',
          service: 'nonprofits',
          filterType: 'multiple'
        },
        {
          label: 'NGO Approved from',
          type: 'service',
          query: 'filter_by_nonprofit',
          placeholder: 'Type nonprofit name',
          service: 'nonprofits',
          filterType: 'multiple'
        },
      ],
      fYears: [{ value: "fy2023-2024", label: "FY 2023-2024" }],
      emailsList: [],
    };
  }

  componentDidMount() {
    const filters = [
      {
        label: "Search",
        type: [
          {
            type: "default",
            label: "Donor Name",
            query: "q",
          },
          {
            type: "nonprofitID",
            label: "Nonprofit ID",
            query: "filter_by_nonprofit_id",
          },
          {
            type: "pan",
            label: "PAN Number",
            query: "filter_by_pan",
          },
          {
            type: 'email',
            label: 'Email id',
            query: 'filter_by_user_email',
          },
          {
            type: "phone",
            label: "Phone",
            query: "filter_by_user_phone",
          },
        ],
        placeholder: "Search for Name, Email, Phone, PAN",
      },
      {
        label: 'Certificates Approved',
        type: 'list',
        query: 'filter_by_status',
        list:[{label: 'All', value:'all'}, {label: 'Complete', value:'complete'}, {label: 'Partial', value:'partial'}],
        filterType: 'multiple'
      },
      {
        label: 'NGO Expected from',
        type: 'service',
        query: 'filter_by_expected_nonprofit',
        placeholder: 'Type nonprofit name',
        service: 'nonprofits',
        filterType: 'multiple'
      },
      {
        label: 'NGO Approved from',
        type: 'service',
        query: 'filter_by_approved_nonprofit',
        placeholder: 'Type nonprofit name',
        service: 'nonprofits',
        filterType: 'multiple'
      },
    ];
    this.setState({ filters, query: Helpers.queryBuilderForFilterInput(filters) }, () => {
      this.refreshNonprofitList();
    });
  }

  componentWillUnmount() {
    const { Emails } = this.props;
    Emails.reset();
  }


  filterOnChange = (filters) => {
    this.setState(
      { filters, query: Helpers.queryBuilderForFilterInput(filters), emailsList: [] },
      () => {
        this.refreshNonprofitList();
      }
    );
  };

  refreshNonprofitList = () => {
    const { Emails } = this.props;
    const { query } = this.state;
    const searchQuery = { ...query };
    this.setState({
      ngoLoader : true
    })
    Emails.reset();
    Emails.getSendEmailsList(searchQuery).then(() => {
      const { emails } = this.props;
      this.setState({ emailsList: emails?.emails10BdBe, ngoLoader : false });
    });
  };

  loadMore = () => {
    const { Emails } = this.props;
    const { query } = this.state;
    this.setState({
      ngoLoader : true
    })
    Emails.getSendEmailsList(query).then(() => {
      const { emails } = this.props;
      this.setState({ emailsList: emails?.emails10BdBe , ngoLoader : false});
    });
  };

  retrieveCheckedItems = (emails) => {
    const formattedData = emails.map((emailsData) => emailsData.user_pan_card);
    this.setState({ onNonProfitsSelected: formattedData });
  };

  handleOnAllItemsSelected = (value) => {
    this.setState({ isAllItemsSelected: value });
  };

  sendEmailNonprofits = (e) => {
    const { Emails } = this.props;
    const isAllItemsSelected = this.state.isAllItemsSelected;
    const userPANs = isAllItemsSelected ? [] : this.state.onNonProfitsSelected;
    const params = {
      ...this.state.query,
    }
    Emails.sendEmailNonprofits(userPANs, { ...params }).then((data) => {});
  };

  render() {
    const { emails } = this.props;
    const { nonprofit_count } = emails || "";
    const { filters, query } = this.state;
    const { status } = query || "";
    return (
      <div className="content-wrapper">
        <div className="row">
          <div className="col-12 grid-margin">
            <div className="card">
              <div className="card-body">
                <div className="row">
                  <h3 className="mr-b-20">Email 10BE Certificates to donors</h3>
                  <div className="col-md-3">
                    <Select isMulti={false} defaultValue={financialYear[0]} isDisabled />
                  </div>
                </div>
                <FilterByInput
                  nonProfitCount={nonprofit_count}
                  value={filters}
                  onChange={this.filterOnChange}
                  isEmailScreen={true}
                />
                <div className="row justify-content-end">
                  <button
                    className="btn btn-primary view-details-btn"
                    style={{ fontSize: "12px", marginBottom:"20px" }}
                    onClick={this.sendEmailNonprofits}
                    disabled={!this.state.onNonProfitsSelected.length > 0}
                    type="submit"
                  >
                    Send Email
                  </button>
                </div>
                <Pagination
                  tableHeading={tableHeading}
                  typeOfTable={"EMAIL_TABLE"}
                  lists={this.state.emailsList}
                  loadMore={this.loadMore}
                  count={nonprofit_count}
                  handleOnAllItemsSelected={this.handleOnAllItemsSelected}
                  retrieveCheckedItems={this.retrieveCheckedItems}
                  onNonProfitsSelected={this.state.onNonProfitsSelected}
                  query={this.state.query}

                  loader={this.state.ngoLoader}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  emails: state.admin10BdBeEmailsList,
});

const mapActionToProps = (dispatch) => ({
  Emails: bindActionCreators(admin10BdBeEmailsListActions, dispatch),
});

export default connect(mapStateToProps, mapActionToProps)(Admin10BeBdEmails);
